import { default as contactsFZ3rCk7skMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/contact.vue?macro=true";
import { default as infosv9dfG1zrejMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/infos.vue?macro=true";
import { default as pdfMn8LqoOEBtMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/pdf.vue?macro=true";
import { default as productsuokE5qwXkBMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/products.vue?macro=true";
import { default as countriesQhcz9s7wxoMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/countries.vue?macro=true";
import { default as currenciesQFQ4xGOELdMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/currencies.vue?macro=true";
import { default as indexh9XWwUDGdfMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/index.vue?macro=true";
import { default as loginUZfW7fL5nnMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/login.vue?macro=true";
import { default as logs4riQPLxOzcMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/logs.vue?macro=true";
import { default as OLD_45productsJojS4pCzR4Meta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/OLD-products.vue?macro=true";
import { default as parameterssnOKhbYnVRMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/parameters.vue?macro=true";
import { default as products9PaDsWT9ZUMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/products.vue?macro=true";
import { default as storeszyD9t3NE3oMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/stores.vue?macro=true";
import { default as usersawCwkyhYahMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/users.vue?macro=true";
import { default as grantvp4sxOv1YwMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/auth/grant.vue?macro=true";
import { default as loginGNhxLNqRnjMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/auth/login.vue?macro=true";
import { default as indexDWol0YEAHqMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/index.vue?macro=true";
import { default as quotevYFmtRFgLaMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/quote.vue?macro=true";
export default [
  {
    name: contactsFZ3rCk7skMeta?.name ?? "quoteid-contact",
    path: contactsFZ3rCk7skMeta?.path ?? "/:quoteid()/contact",
    meta: contactsFZ3rCk7skMeta || {},
    alias: contactsFZ3rCk7skMeta?.alias || [],
    redirect: contactsFZ3rCk7skMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/contact.vue").then(m => m.default || m)
  },
  {
    name: infosv9dfG1zrejMeta?.name ?? "quoteid-infos",
    path: infosv9dfG1zrejMeta?.path ?? "/:quoteid()/infos",
    meta: infosv9dfG1zrejMeta || {},
    alias: infosv9dfG1zrejMeta?.alias || [],
    redirect: infosv9dfG1zrejMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/infos.vue").then(m => m.default || m)
  },
  {
    name: pdfMn8LqoOEBtMeta?.name ?? "quoteid-pdf",
    path: pdfMn8LqoOEBtMeta?.path ?? "/:quoteid()/pdf",
    meta: pdfMn8LqoOEBtMeta || {},
    alias: pdfMn8LqoOEBtMeta?.alias || [],
    redirect: pdfMn8LqoOEBtMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/pdf.vue").then(m => m.default || m)
  },
  {
    name: productsuokE5qwXkBMeta?.name ?? "quoteid-products",
    path: productsuokE5qwXkBMeta?.path ?? "/:quoteid()/products",
    meta: productsuokE5qwXkBMeta || {},
    alias: productsuokE5qwXkBMeta?.alias || [],
    redirect: productsuokE5qwXkBMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/products.vue").then(m => m.default || m)
  },
  {
    name: countriesQhcz9s7wxoMeta?.name ?? "admin-countries",
    path: countriesQhcz9s7wxoMeta?.path ?? "/admin/countries",
    meta: countriesQhcz9s7wxoMeta || {},
    alias: countriesQhcz9s7wxoMeta?.alias || [],
    redirect: countriesQhcz9s7wxoMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/countries.vue").then(m => m.default || m)
  },
  {
    name: currenciesQFQ4xGOELdMeta?.name ?? "admin-currencies",
    path: currenciesQFQ4xGOELdMeta?.path ?? "/admin/currencies",
    meta: currenciesQFQ4xGOELdMeta || {},
    alias: currenciesQFQ4xGOELdMeta?.alias || [],
    redirect: currenciesQFQ4xGOELdMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/currencies.vue").then(m => m.default || m)
  },
  {
    name: indexh9XWwUDGdfMeta?.name ?? "admin",
    path: indexh9XWwUDGdfMeta?.path ?? "/admin",
    meta: indexh9XWwUDGdfMeta || {},
    alias: indexh9XWwUDGdfMeta?.alias || [],
    redirect: indexh9XWwUDGdfMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: loginUZfW7fL5nnMeta?.name ?? "admin-login",
    path: loginUZfW7fL5nnMeta?.path ?? "/admin/login",
    meta: loginUZfW7fL5nnMeta || {},
    alias: loginUZfW7fL5nnMeta?.alias || [],
    redirect: loginUZfW7fL5nnMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/login.vue").then(m => m.default || m)
  },
  {
    name: logs4riQPLxOzcMeta?.name ?? "admin-logs",
    path: logs4riQPLxOzcMeta?.path ?? "/admin/logs",
    meta: logs4riQPLxOzcMeta || {},
    alias: logs4riQPLxOzcMeta?.alias || [],
    redirect: logs4riQPLxOzcMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/logs.vue").then(m => m.default || m)
  },
  {
    name: OLD_45productsJojS4pCzR4Meta?.name ?? "admin-OLD-products",
    path: OLD_45productsJojS4pCzR4Meta?.path ?? "/admin/OLD-products",
    meta: OLD_45productsJojS4pCzR4Meta || {},
    alias: OLD_45productsJojS4pCzR4Meta?.alias || [],
    redirect: OLD_45productsJojS4pCzR4Meta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/OLD-products.vue").then(m => m.default || m)
  },
  {
    name: parameterssnOKhbYnVRMeta?.name ?? "admin-parameters",
    path: parameterssnOKhbYnVRMeta?.path ?? "/admin/parameters",
    meta: parameterssnOKhbYnVRMeta || {},
    alias: parameterssnOKhbYnVRMeta?.alias || [],
    redirect: parameterssnOKhbYnVRMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/parameters.vue").then(m => m.default || m)
  },
  {
    name: products9PaDsWT9ZUMeta?.name ?? "admin-products",
    path: products9PaDsWT9ZUMeta?.path ?? "/admin/products",
    meta: products9PaDsWT9ZUMeta || {},
    alias: products9PaDsWT9ZUMeta?.alias || [],
    redirect: products9PaDsWT9ZUMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/products.vue").then(m => m.default || m)
  },
  {
    name: storeszyD9t3NE3oMeta?.name ?? "admin-stores",
    path: storeszyD9t3NE3oMeta?.path ?? "/admin/stores",
    meta: storeszyD9t3NE3oMeta || {},
    alias: storeszyD9t3NE3oMeta?.alias || [],
    redirect: storeszyD9t3NE3oMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/stores.vue").then(m => m.default || m)
  },
  {
    name: usersawCwkyhYahMeta?.name ?? "admin-users",
    path: usersawCwkyhYahMeta?.path ?? "/admin/users",
    meta: usersawCwkyhYahMeta || {},
    alias: usersawCwkyhYahMeta?.alias || [],
    redirect: usersawCwkyhYahMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: grantvp4sxOv1YwMeta?.name ?? "auth-grant",
    path: grantvp4sxOv1YwMeta?.path ?? "/auth/grant",
    meta: grantvp4sxOv1YwMeta || {},
    alias: grantvp4sxOv1YwMeta?.alias || [],
    redirect: grantvp4sxOv1YwMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/auth/grant.vue").then(m => m.default || m)
  },
  {
    name: loginGNhxLNqRnjMeta?.name ?? "auth-login",
    path: loginGNhxLNqRnjMeta?.path ?? "/auth/login",
    meta: loginGNhxLNqRnjMeta || {},
    alias: loginGNhxLNqRnjMeta?.alias || [],
    redirect: loginGNhxLNqRnjMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: indexDWol0YEAHqMeta?.name ?? "index",
    path: indexDWol0YEAHqMeta?.path ?? "/",
    meta: indexDWol0YEAHqMeta || {},
    alias: indexDWol0YEAHqMeta?.alias || [],
    redirect: indexDWol0YEAHqMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: quotevYFmtRFgLaMeta?.name ?? "quote",
    path: quotevYFmtRFgLaMeta?.path ?? "/quote",
    meta: quotevYFmtRFgLaMeta || {},
    alias: quotevYFmtRFgLaMeta?.alias || [],
    redirect: quotevYFmtRFgLaMeta?.redirect,
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/quote.vue").then(m => m.default || m)
  }
]